import { forwardRef, type ComponentPropsWithoutRef } from "react";
import { Tabs as T } from "radix-ui";
import { cn } from "@/lib/cn";

export const Tabs = T.Root;
export const TabsContent = T.Content;

export const TabsList = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<typeof T.List>>(function TabsList({ className, ...props }, ref) {
  return <T.List ref={ref} className={cn("inline-flex items-center gap-1 rounded-pill bg-slate-900/5 p-1", className)} {...props} />;
});

export const TabsTrigger = forwardRef<HTMLButtonElement, ComponentPropsWithoutRef<typeof T.Trigger>>(function TabsTrigger({ className, ...props }, ref) {
  return (
    <T.Trigger
      ref={ref}
      className={cn(
        "inline-flex h-9 items-center justify-center gap-1.5 whitespace-nowrap rounded-pill px-4 text-sm font-semibold text-slate-600 transition-colors hover:text-slate-900 data-[state=active]:bg-white data-[state=active]:text-slate-900 data-[state=active]:shadow-[0_1px_3px_rgb(15_23_42/0.12)] [&_svg]:size-4",
        className,
      )}
      {...props}
    />
  );
});
